<script setup>
import { computed, inject, onMounted, onUpdated } from 'vue'
import { nanoid } from 'nanoid'

const register = inject('register')
const update = inject('update')

const id  = nanoid(6)
const props = defineProps({
	order: { type: Number, default: 0 },
	fill: { type: String, default: 'black' },
	fontSize: { type: Number, default: 20 },
	strokeColor: { type: String, default: 'red' },
	strokeWidth: { type: Number, default: 0 },
	text: { type: String, default: 'Text' },
	textAlign: {
		type: String,
		default: 'center',
		validator: (val) => [ 'start', 'end', 'left', 'right', 'center', 'justify', 'match-parent', 'justify-all' ].includes(val)
	},
	textBaseline: {
		type: String,
		default: 'middle',
		validator: val => [ 'top', 'hanging', 'middle', 'alphabetic', 'ideographic', 'bottom' ].includes(val)
	},
	x: { type: Number, default: 0 },
	y: { type: Number, default: 0 }
})

const text = computed(() => ({
	id,
	type: 'text',
	order: props.order,
	draw(ctx) {
		const { x, y, text, fill, fontSize, textAlign, textBaseline, strokeWidth, strokeColor } = props
		ctx.fillStyle = fill
		ctx.font = `${fontSize}px sans-serif`
		ctx.textAlign = textAlign
		ctx.textBaseline = textBaseline
		ctx.fillText(
			text,
			x,
			y,
			ctx.width
		)

		if (strokeWidth) {
			ctx.lineWidth = strokeWidth
			ctx.strokeStyle = strokeColor
			ctx.strokeText(
				text,
				x,
				y,
				ctx.width
			)
		}
	}
}))

onMounted(() => register(text.value))
// register(text.value)
onUpdated(() => update(text.value))
</script>

<template>
	<div hidden>
		<!-- text -->
	</div>
</template>
